module.exports = __webpack_public_path__ + "img/logo-header-white.45a70022.svg";